import React from 'react';
import { Text, Button } from '@radix-ui/themes';
import caseStudy from "../../../assets/images/caseStudy.png";

interface AsktoPresentCSProps {
  showButton: boolean;
  onPress: () => void;
  groupName: string;
  presentationRank: any;
}

const AsktoPresentCS: React.FC<AsktoPresentCSProps> = ({ showButton, onPress, groupName, presentationRank }) => {
  return (
    <div className="flex h-[70vh] items-center justify-center relative">
      <div className="absolute top-[9vh] w-full flex justify-center z-50">
        <div className="bg-[rgba(33,32,37,0.8)] w-[55vw] rounded-lg py-2 px-4 border border-[rgba(84,84,85,1)] flex items-center justify-center">
          <Text className="text-[#E9BE50] font-bold text-xs">
            Case Study Debrief in progress
          </Text>
          <div className="w-3" />
          <div className="h-3 w-3 rounded-full bg-green-600 border border-[#E9BE50]" />
        </div>
      </div>

      <div className="bg-[#F1F3FF] w-[80vw] rounded-2xl flex items-center justify-center flex-col mt-[-12vh]">
        <div className="absolute -top-16 h-24 w-24 flex items-center justify-center rounded-full bg-[#E9BE50] border-2 border-white overflow-hidden">
          <img
            src={caseStudy}
            alt="Case Study"
            className="h-16 w-16 object-contain"
          />
        </div>

        <Text className="text-black py-4 text-center font-[Lato-Regular] text-base w-[60vw] mt-20 mb-4">
          Trainer has asked your group to present.
        </Text>

        {showButton && (
          <Button
            onClick={onPress}
            className="bg-green-600 hover:bg-green-700 text-white font-[Lato-Regular] text-sm rounded-xl h-10 px-7 shadow-md mb-6"
          >
            OK
          </Button>
        )}
      </div>
    </div>
  );
};

export default AsktoPresentCS;